import React from 'react';
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { NavLink } from 'react-router-dom';
import { Translate } from "react-localize-redux";
import { Field } from "redux-form";
import InputField from '../InputField';
import DeleteUserButton from '../../DeleteUserButton/DeleteUserButton';
import './AccountFormPanel.scss';

const AccountFormPanel = () => (
  <CollapseContainer
    title={<Translate id="AccountSettings" />}
    startCollapsed={false}
  >
    <div className="row">
      <div className="col-11 offset-1">

        {/*<div className="form-row">*/}
        {/*  <label*/}
        {/*    className="col-sm-3"*/}
        {/*    htmlFor="username">*/}
        {/*    <Translate id="Username" />*/}
        {/*  </label>*/}
        {/*  <div className="col-5">*/}
        {/*    <Field*/}
        {/*      label={<Translate id="Username" />}*/}
        {/*      hideLabel={true}*/}
        {/*      name="username"*/}
        {/*      type="text"*/}
        {/*      id="username-input"*/}
        {/*      component={InputField}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}

        <div className="form-row password-form-row">
          <label
            className="col-sm-3"
            htmlFor="password">
            <Translate id="Password" />
          </label>
          <div className="col-5">
          </div>
          <div className="col-3">
            <NavLink
              to="/change-password"
              className="btn grey-btn"
            >
              <Translate id="Change" />
            </NavLink>
          </div>
        </div>

        <div className="form-row">
          <label
            className="col-sm-3"
            htmlFor="phone_number">
            <Translate id="PhoneNumber" />
          </label>
          <div className="col-5">
            <Field
              label={<Translate id="PhoneNumber" />}
              hideLabel={true}
              name="validated_phone_number"
              type="text"
              id="phone-number-input"
              component={InputField}
              disabled
            />
          </div>
          <div className="col-3">
            <NavLink
              to="/confirm-number"
              className="btn grey-btn"
            >
              <Translate id="Change" />
            </NavLink>
          </div>
        </div>

        <div className="form-row">
          <label
            className="col-sm-3"
            htmlFor="email">
            <Translate id="Email" />
          </label>
          <div className="col-5">
            <Field
              label={<Translate id="Email" />}
              hideLabel={true}
              name="email"
              type="text"
              id="email-input"
              component={InputField}
            />
          </div>
          <div className="col-3 required-text">
            <p>*<Translate id="RequiredText" /></p>
          </div>
        </div>

        <div className="form-row">
          <div className="col-12">
            <DeleteUserButton />
          </div>
        </div>
      </div>
    </div>
  </CollapseContainer>
);

export default AccountFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/AccountFormPanel/AccountFormPanel.jsx